// Formatage des dates au format JJ/MM/AAAA (avec slashes) — standard de l'app.
// Utiliser partout à la place de toLocaleDateString / new Date().toLocaleDateString.

export function formatDateFR(value) {
  if (!value && value !== 0) return '';
  const s = String(value);
  // Déjà au format ISO 'YYYY-MM-DD...' -> conversion directe (évite les décalages de fuseau)
  const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) return `${iso[3]}/${iso[2]}/${iso[1]}`;
  // Déjà 'DD/MM/YYYY' -> conservé
  const fr = s.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
  if (fr) return `${fr[1]}/${fr[2]}/${fr[3]}`;
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return s;
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  return `${dd}/${mm}/${d.getFullYear()}`;
}

export function formatDateTimeFR(value) {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return formatDateFR(value);
  const hh = String(d.getHours()).padStart(2, '0');
  const mi = String(d.getMinutes()).padStart(2, '0');
  return `${formatDateFR(d)} ${hh}:${mi}`;
}
